<template>
  <!-- Phone version of a checklist row: read-only, title only (no pitch copy);
  the CTA becomes a "Finish on desktop" pill. -->
  <div class="rounded-lg px-3 py-3">
    <div class="flex items-start gap-3">
      <div
        class="flex-shrink-0 w-6 h-6 mt-0.5 rounded-full border-2 flex items-center justify-center"
        :class="step.done
          ? 'bg-primary-green-100 border-primary-green-100 text-white'
          : showPadlock
            ? 'bg-neutral-25 border-neutral-50 text-icon-disabled'
            : 'bg-white border-neutral-100 text-transparent'"
      >
        <svg
          v-if="showPadlock"
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="11"
          viewBox="0 0 12 12"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect
            x="2.25"
            y="5.25"
            width="7.5"
            height="5.5"
            rx="1.25"
          />
          <path d="M4 5.25V3.75a2 2 0 0 1 4 0v1.5" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M2 6.5l2.5 2.5L10 3.5" />
        </svg>
      </div>

      <div class="flex-grow min-w-0">
        <BaseText
          type="label"
          size="sm"
          :line-through="step.done"
          :class="step.done ? 'text-text-subdued' : 'text-text-loud'"
        >
          {{ step.content.title }}
        </BaseText>
        <div
          v-if="!step.done"
          class="mt-2 flex items-center gap-2 flex-wrap"
        >
          <div class="px-2 py-0.5 rounded-md bg-neutral-25">
            <BaseText
              type="label"
              size="xs"
              class="text-text-muted"
            >
              {{ step.skipped ? skippedLabel : pillLabel }}
            </BaseText>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SETUP_SKIP } from '@/utils/setup/setupContent'

export default {
  name: 'SetupPhoneTaskRow',
  props: {
    // Resolved step, same shape SetupTaskRow receives
    step: {
      type: Object,
      required: true
    },
    pillLabel: {
      type: String,
      required: true
    }
  },
  data () {
    return { skippedLabel: SETUP_SKIP.skippedLabel }
  },
  computed: {
    showPadlock () {
      return !this.step.done && !this.step.skipped && (this.step.locked || this.step.productLocked)
    }
  }
}
</script>
